import { isDefined } from '@sravni/react-utils';

import type { List } from '@src/@types/microcredits';
import { getRateRangeString } from '@src/helpers/common';

export const getOfferRate = (rates: List.IMicrocreditDetails[]) => {
  if (!rates.length) {
    return '—';
  }

  const froms = rates.map((r) => r.rate.from).filter(isDefined);
  const tos = rates.map((r) => r.rate.to).filter(isDefined);

  if (!froms.length && !tos.length) {
    return '—';
  }

  const range = {
    from: froms.length ? Math.min(...froms) : 0,
    to: tos.length ? Math.max(...tos) : 0,
  };

  return `${getRateRangeString(range, true, false, true)}%`;
};
